var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#a2a6a8",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.784 8h11.351"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2a6a8",
    d: "M6.605 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapDot);
export default __webpack_public_path__ + "static/media/cap_dot.141746d3edf5b9759313b286975be319.svg";
export { ForwardRef as ReactComponent };